import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import SectionTitle from '../../../components/shared/section-title'
import Heading from '../../../components/shared/heading'
import Text from '../../../components/shared/text'
import Link from '../../../components/shared/link'
import LeafletMap from '../../../components/map/index'
// import MapContainer from '../../../components/map'
import {SectionWrap, ContactInfoWrap, SingleInfo, MapWrapper} from './contact-info.stc'

const ContactInfo = ({infoTextStyle, infoHeadingStyle, infoLinkStyle}) => {

    const siteQueryData = useStaticQuery(graphql `
        query contactSiteDataQuery {
            site {
                siteMetadata {
                  contact {
                    company_address
                    company_email
                    phone
                    phone2
                  }
                }
            }
        }      
    `);
    const {company_address, company_email, phone, phone2} = siteQueryData.site.siteMetadata.contact
    return (
        <SectionWrap>
            <div className="row justify-content-between align-items-center">
                <div className="col-1 offset-1">
                    <ContactInfoWrap>
                        <SectionTitle
                            title="Infos de contact"
                        />
                        {company_address && (
                            <SingleInfo className="wow fadeInLeft" data-wow-delay="300ms" data-wow-duration="1000ms">
                                <Text {...infoTextStyle}>Addresse</Text>
                                <Heading {...infoHeadingStyle}>
                                    <Link {...infoLinkStyle} path={"https://goo.gl/maps/9F33YVP7ibHEFcNEA"}>
                                    {company_address}
                                    </Link>
                                </Heading>
                            </SingleInfo>
                        )}
                        {company_email && (
                            <SingleInfo className="wow fadeInLeft" data-wow-delay="500ms" data-wow-duration="1000ms">
                                <Text {...infoTextStyle}>E-mail</Text>
                                <Heading {...infoHeadingStyle}>
                                    <Link {...infoLinkStyle} path={`mailto:${company_email}`}>{company_email}</Link>
                                </Heading>
                            </SingleInfo>
                        )}

                        <SingleInfo className="wow fadeInLeft" data-wow-delay="700ms" data-wow-duration="1000ms">
                            <Text {...infoTextStyle}>Téléphone</Text>
                            {phone && <Heading {...infoHeadingStyle}><Link {...infoLinkStyle} path={`tel:${phone}`}>{phone}</Link></Heading>}
                            {phone2 && <Heading {...infoHeadingStyle}><Link {...infoLinkStyle} path={`tel:${phone2}`}>{phone2}</Link></Heading>}
                        </SingleInfo>
                    </ContactInfoWrap>
                </div>
                <div className="col-3 offset-1">
                    <MapWrapper>
                    {typeof window !== 'undefined' &&
                        <LeafletMap />
                    }
                    {/* <iframe title="carte de jardipiscines" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2898.6661067752593!2d6.077938615489742!3d43.40490777913066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12c9421b6b8a33af%3A0xdf81d19a403a790a!2s3%20Rue%20des%20Pistoles%2C%2083170%20Brignoles!5e0!3m2!1sfr!2sfr!4v1614260590022!5m2!1sfr!2sfr" width="100%" height="100%" style={{ border: "0" }} allowfullscreen="" loading="lazy"/> */}
                        {/* <MapContainer/> */}
                    </MapWrapper>
                </div>
            </div>
        </SectionWrap>
    )
}

ContactInfo.propTypes = {
    infoTextStyle: PropTypes.object,
    infoHeadingStyle: PropTypes.object
}

ContactInfo.defaultProps = {
    infoTextStyle: {
        fontSize: '12px',
        color: '#000',
        opacity: 0.8,
        fontweight: 400,
        texttransform: 'uppercase',
        mb: '5px'
    },
    infoHeadingStyle: {
        as: 'h6',
        fontSize: '12px',
        fontweight: 600,
        color: '#000',
        letterspacing: '0.5px',
        mb: 0,
        lineHeight: '22px'
    },
    infoLinkStyle: {
        color: '#000'
    }
}

export default ContactInfo
